import React from "react";

import { useCommonContext } from "../../context/common-context";

import Categories from "../../common/categories";
import "../help/help.scss";
import HelpWrapper from "../help/help-wrapper";
import OrderDetailsCard from "../help/cards/order-details-card";
import { CommonModule } from "uca-react-containers-library";
import ucaEnv from "../../../common/env/env-uca";
import { useApi } from "../../../hooks";
import OrdersSvg from "../help/icons/orders.svg";
import { setCookie } from "../../../helpers/common";
import { NO_ORDERS } from "../help/constants";

const Orders = ({}) => {
  const {
    user,
    bannerFAQ,
    appData: { banner },
    isGuest,
  } = useCommonContext();

  let apiResponse;
  if (!isGuest) {
    const {
      appData: { env, platform },
    } = CommonModule.useApp();
    const environmentVariables = ucaEnv(banner, env, platform);
    const { data } = useApi(
      `${environmentVariables.REWARDS_PAGE_BASE_API}/customer/orders`
    );
    apiResponse = data;
  } else {
    setCookie(
      "ECommRedirectURL",
      encodeURIComponent(`${window.location.origin}/help/orders`)
    );
    window.location.href = "/account/sign-in.html";
  }

  const defaultOrders = (apiResponse && apiResponse.orders) || [];

  let orderCards = defaultOrders.map((item) => ({
    title: item.status,
    desc: item.message,
    link: {
      label:
        item.editEligible && item.status !== "Order Canceled"
          ? "Modify order"
          : item.refundEligible && item.status !== "Order Canceled"
          ? "Request Refund"
          : "View order",
      href: item.editEligible
        ? "/order-account/orders/" + item.orderNumber
        : item.refundEligible
        ? `/order-account/orders/${item.orderNumber}/report-issue `
        : "/order-account/orders/" + +item.orderNumber,
    },
    allow: ["guest", "user"],
    id: item.orderNumber,
    Card: OrderDetailsCard,
    image: OrdersSvg,
  }));

  orderCards =
    orderCards.length > 0
      ? [
          ...orderCards,
          {
            title: "Orders",
            desc: "See all orders over last 90 days",
            link: {
              label: "View all orders",
              href: "/order-account/orders",
            },
            allow: ["guest", "user"],
            id: "99999",
            Card: OrderDetailsCard,
            image: OrdersSvg,
          },
        ]
      : orderCards;

  const breadCrumblist = [
    {
      label: "Contact Us",
      href: "/help/home",
    },
    {
      label: "Orders",
    },
  ];

  const totalFaq = bannerFAQ.filter(
    (item) => item && item.category && item.category.includes(1)
  );

  return (
    <HelpWrapper
      breadCrumb={breadCrumblist}
      faqList={totalFaq}
      showTitle={false}
      showAll={true}
      showChat={false}
      faqRoute="orders"
      showSurvey = {false}
    >
      <Categories
        isGuest={isGuest}
        banner={banner}
        user={user}
        data={orderCards.length > 0 ? orderCards : NO_ORDERS}
        title="Orders"
      />
    </HelpWrapper>
  );
};

export default Orders;
